import { getCookieValue } from '../consent/cookieUtils';
import { POSTHOG_COOKIE_NAME } from './constants';
import { PostHog$CookieValue } from './types';

export function convertPosthogCookieToSearchParams() {
  const postHogSearchParams = new URLSearchParams();
  const postHogCookieValue = getCookieValue(POSTHOG_COOKIE_NAME);

  if (postHogCookieValue) {
    // Decode PostHog cookie to prevent double encoding in search params
    const decodedValue = decodeURIComponent(postHogCookieValue);
    postHogSearchParams.set(POSTHOG_COOKIE_NAME, decodedValue);
    return postHogSearchParams;
  }
  return null;
}

export function convertPosthogCookieToObject(): PostHog$CookieValue | null {
  const postHogCookieValue = getCookieValue(POSTHOG_COOKIE_NAME);

  if (postHogCookieValue) {
    try {
      return JSON.parse(postHogCookieValue);
    } catch (_) {
      // it's ok
    }
  }

  return null;
}

export function getPosthogCookieValueAsLabel(
  posthogCookie: PostHog$CookieValue | null,
) {
  if (posthogCookie) {
    return `${posthogCookie.experimentName}:${posthogCookie.variantName}`;
  }
  return null;
}
